<template>
  <div class="dashboard-page py-5">
    <b-container>
      <!-- Header -->
      <b-row class="mb-4 align-items-center">
        <b-col>
          <h1 class="h3 font-weight-bold">{{ $t('dashboard.welcome') }}</h1>
          <p class="text-muted">{{ user ? user.email : '' }}</p>
        </b-col>
        <b-col text-right>
           <!-- Payout Button (Future) -->
           <b-button variant="outline-success" disabled>
             {{ $t('dashboard.withdraw_funds') }} ($10.00 min)
           </b-button>
        </b-col>
      </b-row>

      <!-- Stats Cards -->
      <b-row class="mb-5">
        <b-col md="4" class="mb-3">
          <b-card bg-variant="success" text-variant="white" class="text-center shadow-sm border-0">
             <h6 class="text-uppercase mb-2 text-white-50">{{ $t('dashboard.balance') }}</h6>
             <h2 class="font-weight-bold">${{ balance.toFixed(2) }}</h2>
          </b-card>
        </b-col>
        <b-col md="4" class="mb-3">
           <b-card class="text-center shadow-sm border-0">
             <h6 class="text-uppercase mb-2 text-muted">{{ $t('dashboard.lifetime_earnings') }}</h6>
             <h2 class="font-weight-bold text-dark">$0.00</h2>
          </b-card>
        </b-col>
        <b-col md="4" class="mb-3">
           <b-card class="text-center shadow-sm border-0">
             <h6 class="text-uppercase mb-2 text-muted">{{ $t('dashboard.clicks') }}</h6>
             <h2 class="font-weight-bold text-dark">0</h2>
          </b-card>
        </b-col>
      </b-row>

      <!-- Recent Activity -->
      <h4 class="mb-3">{{ $t('dashboard.recent_activity') }}</h4>
      <b-card class="shadow-sm border-0 mb-5">
        <div v-if="loading" class="text-center py-4">
          <b-spinner small></b-spinner> Loading activity...
        </div>
        
        <div v-else-if="clicks.length === 0" class="text-center text-muted py-5">
          <b-icon-clock-history scale="2" class="mb-3"></b-icon-clock-history>
          <p>{{ $t('dashboard.no_activity') }}</p>
          <b-button to="/" variant="success" size="sm">{{ $t('nav.start_shopping') }}</b-button>
        </div>

        <b-table 
          v-else 
          striped 
          hover 
          :items="clicks" 
          :fields="fields" 
          responsive="sm"
          class="mb-0"
        >
           <template #cell(timestamp)="data">
             {{ formatDate(data.value) }}
           </template>
           <template #cell(status)="data">
             <b-badge :variant="getStatusVariant(data.value)">{{ data.value }}</b-badge>
           </template>
        </b-table>
      </b-card>

    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { db } from '../main';

export default {
  name: 'Dashboard',
  data() {
    return {
      clicks: [],
      loading: true,
      fields: [
        { key: 'timestamp', label: 'Date', sortable: true },
        { key: 'productName', label: 'Store/Product' },
        { key: 'status', label: 'Status' }
      ]
    }
  },
  computed: {
    ...mapState(['user', 'balance'])
  },
  async mounted() {
    // 1. Fetch User Profile
    if (this.user) {
      this.$store.dispatch('fetchUserProfile');
      await this.fetchClicks();
    }
  },
  methods: {
    async fetchClicks() {
      try {
        const snapshot = await db.collection('Clicks')
          .where('userId', '==', this.user.uid)
          .orderBy('timestamp', 'desc')
          .limit(20)
          .get();
        
        this.clicks = snapshot.docs.map(doc => {
            const data = doc.data();
            return {
                id: doc.id,
                ...data,
                // Handle Firestore Timestamp or JS Date
                timestamp: data.timestamp && data.timestamp.toDate ? data.timestamp.toDate() : new Date(data.timestamp)
            }
        });
      } catch (error) {
        console.error("Error fetching clicks:", error);
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
        if (!date) return '';
        return new Date(date).toLocaleString();
    },
    getStatusVariant(status) {
        if (status === 'clicked') return 'info';
        if (status === 'confirmed') return 'success';
        return 'secondary';
    }
  }
}
</script>

<style scoped>
.dashboard-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}
</style>
